<div class="corporate-dashboard">
	<div class="page-title">Corporate Reporting Portal</div>

	<div class="toolbar-row">
		<div class="toolbar-main">
			<app-corporate-filters-bar
				[properties]="(properties$ | async) ?? []"
				[organisations]="(organisations$ | async) ?? []"
				[organisationId]="(organisationId$ | async)"
				(organisationChanged)="onOrganisationChanged($event)"
				(filtersChanged)="onFiltersChanged($event)"
			></app-corporate-filters-bar>
		</div>
	</div>

	<div
		*ngIf="(loading$ | async) === false && (errorStatus$ | async) !== null as err"
		class="card p-3 mt-3"
	>
		Error loading data ({{ err }}).
	</div>

	<!-- Main layout -->
	<div class="grid content-grid">
		<div class="col-12 lg:col-8">
			<app-portfolio-risk-chart
				[title]="riskTitle$ | async"
				[series]="riskSeries$ | async"
				[loading]="(loading$ | async) ?? false"
				[errorStatus]="errorStatus$ | async"
			></app-portfolio-risk-chart>
		</div>

		<div class="col-12 lg:col-4">
			<app-portfolio-snapshot-card
				[snapshot]="snapshot$ | async"
				[loading]="(loading$ | async) ?? false"
				[errorStatus]="errorStatus$ | async"
				[highRiskHotelsCount]="highRiskHotelsCount$ | async"
				[highRiskReportsCount]="highRiskReportsCount$ | async"
			></app-portfolio-snapshot-card>
		</div>

		<div class="col-12">
			<div class="high-risk-shell">
				<app-high-risk-section></app-high-risk-section>
			</div>
		</div>

		<div class="col-12">
			<app-performance-hotels-panel></app-performance-hotels-panel>
		</div>
	</div>
</div>
